module.exports = __webpack_public_path__ + "static/media/ic-2.47c4c015.svg";